type Context = {
  baseUrl: string
  params: Params[]
}

type ExternalMarket = {
  [key: string]: Context
}

type Params = {
  mappingKey: string
  type: string
}

export const externalMarkets: ExternalMarket = {
  AU: {
    baseUrl: 'https://fg.unicity.com/australia',
    params: [
      {
        mappingKey: 'refCode',
        type: 'page2page',
      },
    ],
  },
  HK: {
    baseUrl: 'https://fg.unicity.com/hongkong',
    params: [
      {
        mappingKey: 'refCode',
        type: 'page2page',
      },
    ],
  },
  JP: {
    baseUrl: 'https://fg.unicity.com/japan',
    params: [
      {
        mappingKey: 'refCode',
        type: 'page2page',
      },
    ],
  },
  KW: {
    baseUrl: 'https://fg.unicity.com/kuwait',
    params: [
      {
        mappingKey: 'refCode',
        type: 'page2page',
      },
    ],
  },
  MY: {
    baseUrl: 'https://fg.unicity.com/malaysia',
    params: [
      {
        mappingKey: 'refCode',
        type: 'page2page',
      },
    ],
  },
  NZ: {
    baseUrl: 'https://fg.unicity.com/newzealand',
    params: [
      {
        mappingKey: 'refCode',
        type: 'page2page',
      },
    ],
  },
  PH: {
    baseUrl: 'https://fg.unicity.com/philippines',
    params: [
      {
        mappingKey: 'refCode',
        type: 'page2page',
      },
    ],
  },
  SG: {
    baseUrl: 'https://fg.unicity.com/singapore',
    params: [
      {
        mappingKey: 'refCode',
        type: 'page2page',
      },
    ],
  },
  TW: {
    baseUrl: 'https://fg.unicity.com/taiwan',
    params: [
      {
        mappingKey: 'refCode',
        type: 'page2page',
      },
    ],
  },
  ZA: {
    baseUrl: 'https://fg.unicity.com/southafrica',
    params: [
      {
        mappingKey: 'refCode',
        type: 'page2page',
      },
    ],
  },
}
